import { useState } from 'react';
import { useAuthContext } from './useAuthContext';

function loginErrorMessage(detail) {
  const message = Array.isArray(detail) ? detail.join(' ') : detail;
  if (
    message === 'No active account found with the given credentials' ||
    message === 'Password is incorrect'
  ) {
    return 'Incorrect password, or your account is not verified yet. Check webmail for the verification link.';
  }
  return message || 'Login failed. Please try again.';
}

export const useLogin = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { dispatch } = useAuthContext();

  const login = async (username, password) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch('/api/authenticate/token/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        body: JSON.stringify({ username, password }),
      });

      const json = await response.json();
      if (!response.ok) {
        setError(loginErrorMessage(json.detail));
        return;
      }

      localStorage.setItem('user', JSON.stringify(json));
      dispatch({ type: 'LOGIN', payload: json });
    } catch (e) {
      setError('Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return { login, isLoading, error };
};
